import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mt-0" }
const _hoisted_2 = {
  key: 0,
  d: "M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z",
  "fill-rule": "evenodd",
  sandboxuid: "0"
}
const _hoisted_3 = {
  key: 1,
  d: "M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z",
  sandboxuid: "0"
}
const _hoisted_4 = { class: "d-grid gap-2" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = {
  version: "1.2",
  style: {"overflow":"visible","width":"299px","height":"1px","opacity":"1","mix-blend-mode":"normal"}
}
const _hoisted_8 = { class: "d-flex search-buttons mx-auto" }

import SearchFormContent from "@/components/UnexpectedEventAndAlertStatuseList/SearchFormContent.vue";
import { SELECTABLE_STATUSES } from '@/services/consts/unecpected_event_and_alert_status';
import { Ref, reactive, ref, computed, watch } from 'vue';
import i18n from '@/lang/i18n';
import { getDateRangeDays } from '@/services/functions';
import { getDatetimeWithoutSeconds } from "@/services/functions";

const MAX_FILTER_DAYS = 21;


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchForm',
  props: {
    isLoading: { type: Boolean },
    isManagementOffice: { type: Boolean },
    isSubManagementOffice: { type: Boolean },
    isOperationOffice: { type: Boolean },
    isDepartment: { type: Boolean }
  },
  emits: ['search', 'formchange'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit
const hide: Ref<boolean> = ref(false)
let form: any = reactive({
  dateRange: [
    new Date(),
    new Date()
  ],
  includes_start_or_end_time: 'start_time',
  division: SELECTABLE_STATUSES[0],
})
const errors: any = reactive({})

const title = computed(() => {
  return hide.value ? "" : i18n.global.t('pages.common.filter.title')
})

const searchAreaClass = computed(() => {
  return hide.value ? "search-area-hide p-4" : "search-area p-4"
})

const operationOfficeClearable = computed(() => {
  return props.isManagementOffice || props.isSubManagementOffice
})

function clearForm () {
  form.dateRange = [
    new Date(),
    new Date()
  ]
  form.includes_start_or_end_time = 'start_time'
  form.division = SELECTABLE_STATUSES[0]
  form.managementOffice = props.isManagementOffice ? undefined : form.managementOffice
  form.operationOffice = operationOfficeClearable.value ? undefined : form.operationOffice
  form.group = undefined
  form.department = undefined
  form.vehicle = undefined
  form.driver = undefined
}

function toggleSidebar () {
  hide.value = !hide.value
}

const changeSearchButton = computed(() => {
  return props.isLoading ? i18n.global.t('pages.common.button.loading') : i18n.global.t('pages.common.button.exec')
})

function handleClickSearch() {
  if (validateForm()) return
  emits('search', form, true)
}

function validateForm() {
  clearErrors()
  if (!form.operationOffice) errors.operationOffice = [i18n.global.t('pages.common.filter.errorMssages.pleaseSelect')]
  if (!form.dateRange[0] || !form.dateRange[1] || getDatetimeWithoutSeconds(form.dateRange[0]) > getDatetimeWithoutSeconds(form.dateRange[1])) {
    errors.start_time = [i18n.global.t('pages.common.filter.errorMssages.pleaseSelectCorrectRange')]
  } else if (getDateRangeDays(form.dateRange[0], form.dateRange[1]) > MAX_FILTER_DAYS) {
    errors.start_time = [`${i18n.global.t('pages.common.filter.errorMssages.range')}${MAX_FILTER_DAYS}${i18n.global.t('pages.common.filter.errorMssages.pleaseSelectWithinDays')}`]
  }
  return (errors.operationOffice?.length || errors.start_time?.length)
}

function clearErrors() {
  errors.operationOffice = []
  errors.start_time = []
}

function makeInitialForms() {
  if (props.isOperationOffice || props.isDepartment) {
    form.start_time = new Date()
    form.start_time.setDate(form.start_time.getDate() - 3)
  }
}

watch(form, () => {
  emits('formchange', form)
})
watch(() => props.isOperationOffice, () => {
  makeInitialForms()
});
watch(() => props.isDepartment, () => {
  makeInitialForms()
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(searchAreaClass.value)
  }, [
    _createElementVNode("h4", _hoisted_1, [
      _createTextVNode(_toDisplayString(title.value) + " ", 1),
      (_openBlock(), _createElementBlock("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fit: "",
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        sandboxuid: "0",
        onClick: toggleSidebar
      }, [
        (hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
          : _createCommentVNode("", true),
        (!hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`strpied-tabled-with-hover ${hide.value ? 'd-none' : '' }`)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SearchFormContent, {
          modelValue: _unref(form),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(form) ? (form).value = $event : form = $event)),
          maxFilterDays: MAX_FILTER_DAYS,
          errors: errors,
          operationOfficeClearable: operationOfficeClearable.value,
          isManagementOffice: props.isManagementOffice,
          isDepartment: props.isDepartment
        }, null, 8, ["modelValue", "errors", "operationOfficeClearable", "isManagementOffice", "isDepartment"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("defs", null, [
              _createElementVNode("path", {
                id: "path-1650848226989195",
                d: "M1126 703 C1126 703 1425 703 1425 703"
              })
            ], -1),
            _createElementVNode("g", { transform: "translate(-1126, -703)" }, [
              _createElementVNode("path", {
                style: {"stroke":"rgb(194, 186, 186)","stroke-width":"1","stroke-linecap":"butt","stroke-linejoin":"miter","fill":"none"},
                d: "M1126 703 C1126 703 1425 703 1425 703"
              })
            ], -1)
          ]))]))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_btn, {
            class: "ma-2 exec-btn",
            onClick: handleClickSearch,
            disabled: props.isLoading,
            style: _normalizeStyle({
              backgroundColor : props.isLoading ? '#B3B8BB' : ''
            })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(changeSearchButton.value), 1)
            ]),
            _: 1
          }, 8, ["disabled", "style"]),
          _createVNode(_component_v_btn, {
            class: "ma-2 reset-btn",
            disabled: props.isLoading,
            onClick: clearForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ], 2)
  ], 2))
}
}

})